const BASE_CONST = 'INVENTORY_PURCHASE_ORDER_'

export const INVENTORY_PURCHASE_ORDER_SET_PURCHASE_ORDER = `${BASE_CONST}SET_PURCHASE_ORDER`

export const INVENTORY_PURCHASE_ORDER_PAGE_REQUEST = `${BASE_CONST}PAGE_REQUEST`

export const INVENTORY_PURCHASE_ORDER_SET_OUTLETS = `${BASE_CONST}SET_OUTLETS`

export const INVENTORY_PURCHASE_ORDER_PURCHASE_ORDER_REQUEST = `${BASE_CONST}PURCHASE_ORDER_REQUEST`

export const INVENTORY_PURCHASE_ORDER_OPEN_RIGHT_COLUMN = `${BASE_CONST}OPEN_RIGHT_COLUMN`

export const INVENTORY_PURCHASE_ORDER_CLOSE_RIGHT_COLUMN = `${BASE_CONST}CLOSE_RIGHT_COLUMN`

export const INVENTORY_PURCHASE_ORDER_ON_CLICK_ROW = `${BASE_CONST}ON_CLICK_ROW`

export const INVENTORY_PURCHASE_ORDER_SET_TOTAL_PAGE = `${BASE_CONST}SET_TOTAL_PAGE`

export const INVENTORY_PURCHASE_ORDER_SET_CURRENT_PAGE = `${BASE_CONST}SET_CURRENT_PAGE`

export const INVENTORY_PURCHASE_ORDER_ON_CHANGE_OUTLET_IDS = `${BASE_CONST}ON_CHANGE_OUTLET_IDS`

export const INVENTORY_PURCHASE_ORDER_ON_CHANGE_DATE = `${BASE_CONST}ON_CHANGE_DATE`

export const INVENTORY_PURCHASE_ORDER_ON_CHANGE_NAMESPACE = `${BASE_CONST}ON_CHANGE_NAMESPACE`

export const INVENTORY_PURCHASE_ORDER_ON_CHANGE_STATUS = `${BASE_CONST}ON_CHANGE_STATUS`

export const INVENTORY_PURCHASE_ORDER_ON_CHANGE_KEYWORD = `${BASE_CONST}ON_CHANGE_KEYWORD`

export const INVENTORY_PURCHASE_ORDER_EXPORT_PURCHASE_ORDER = `${BASE_CONST}EXPORT_PURCHASE_ORDER`

export const INVENTORY_PURCHASE_ORDER_ON_CLICK_DONE = `${BASE_CONST}ON_CLICK_DONE`

export const INVENTORY_PURCHASE_ORDER_SET_PURCHASE_ORDER_DETAIL = `${BASE_CONST}PURCHASE_ORDER_DETAIL`

export const INVENTORY_PURCHASE_ORDER_ON_CLICK_PRINT = `${BASE_CONST}ON_CLICK_PRINT`

export const INVENTORY_PURCHASE_ORDER_ON_CLICK_RESEND_EMAIL = `${BASE_CONST}ON_CLICK_RESEND_EMAIL`

export const INVENTORY_PURCHASE_ORDER_SET_SUPPLIERS = `${BASE_CONST}SET_SUPPLIERS`

export const INVENTORY_PURCHASE_ORDER_ON_CLICK_CREATE_PO = `${BASE_CONST}ON_CLICK_CREATE_PO`

export const INVENTORY_PURCHASE_ORDER_ON_CLICK_CANCEL = `${BASE_CONST}ON_CLICK_CANCEL`

export const INVENTORY_PURCHASE_ORDER_UPDATE_PURCHASE_ORDER = `${BASE_CONST}UPDATE_PURCHASE_ORDER`

export const INVENTORY_PURCHASE_ORDER_SHOW_MODAL_ITEM = `${BASE_CONST}SHOW_MODAL_ITEM`

export const INVENTORY_PURCHASE_ORDER_CLOSE_MODAL_ITEM = `${BASE_CONST}CLOSE_MODAL_ITEM`

export const INVENTORY_PURCHASE_ORDER_IS_LOADING = `${BASE_CONST}IS_LOADING`

export const INVENTORY_PURCHASE_ORDER_SET_DATA_SEARCH = `${BASE_CONST}SET_ITEM`

export const INVENTORY_PURCHASE_ORDER_GET_ITEMS_FROM_API = `${BASE_CONST}GET_ITEMS_FROM_API`

export const INVENTORY_PURCHASE_ORDER_SET_SELECTED_OUTLET = `${BASE_CONST}SET_SELECTED_OUTLET`

export const INVENTORY_PURCHASE_ORDER_SET_ADDED_ITEM = `${BASE_CONST}SET_ADDED_ITEM`

export const INVENTORY_PURCHASE_ORDER_ON_CANCEL_MODAL_ADD_ITEM = `${BASE_CONST}ON_CANCEL_MODAL_ADD_ITEM`

export const INVENTORY_PURCHASE_ORDER_SET_MODAL_DATA_FORM = `${BASE_CONST}SET_MODAL_ITEM_FORM`

export const INVENTORY_PURCHASE_ORDER_SET_IS_ITEM_ADDED = `${BASE_CONST}SET_IS_ITEM_ADDED`

export const INVENTORY_PURCHASE_ORDER_ADD_ITEM_TO_FORM = `${BASE_CONST}ADD_ITEM_TO_FORM`

export const INVENTORY_PURCHASE_ORDER_CREATE_PURCHASE_ORDER = `${BASE_CONST}CREATE_PURCHASE_ORDER`

export const INVENTORY_PURCHASE_ORDER_CREATE_AND_FULFILLED_PURCHASE_ORDER = `${BASE_CONST}CREATE_AND_FULFILLED_PURCHASE_ORDER`

export const INVENTORY_PURCHASE_ORDER_EDIT_PURCHASE_ORDER = `${BASE_CONST}EDIT_PURCHASE_ORDER`

export const INVENTORY_PURCHASE_ORDER_ON_CHANGE_OUTLET_FORM = `${BASE_CONST}ON_CHANGE_OUTLET_FORM`

export const INVENTORY_PURCHASE_ORDER_ON_CLICK_EDIT = `${BASE_CONST}ON_CLICK_EDIT`

export const INVENTORY_PURCHASE_ORDER_SHOW_CONFIRM_SUBMIT_MODAL = `${BASE_CONST}SHOW_CONFIRM_SUBMIT_MODAL`

export const INVENTORY_PURCHASE_ORDER_HIDE_CONFIRM_SUBMIT_MODAL = `${BASE_CONST}HIDE_CONFIRM_SUBMIT_MODAL`

export const INVENTORY_PURCHASE_ORDER_SET_FIRST_ITEMS = `${BASE_CONST}SET_FIRST_ITEMS`



// WEBPACK FOOTER //
// ./app/actions/inventory/purchaseOrder/constants.js